import {
  ComparisonOption as ComparisonOptionType,
  teamOptionValue,
  companyOptionValue,
  selfOptionValue,
  lastYearValue,
  allTeamsOptionValue,
  allGroupsOptionValue
} from 'alchemyScorecard/types';

export type ComparisonOption = ComparisonOptionType;

export const teamOption: ComparisonOption = {
  value: teamOptionValue,
  label: 'Team',
  shortLabel: 'Team',
};
export const allTeamsOption: ComparisonOption = {
  value: allTeamsOptionValue,
  label: 'All Teams',
  shortLabel: 'All Teams',
};
export const allGroupsOption: ComparisonOption = {
  value: allGroupsOptionValue,
  label: 'All Groups',
  shortLabel: 'All Groups',
};
export const companyOption: ComparisonOption = {
  value: companyOptionValue,
  label: 'Company',
  shortLabel: 'Company',
};
export const selfOption: ComparisonOption = {
  value: selfOptionValue,
  label: 'Previous time-period',
  shortLabel: 'Previous',
};
export const lastYearOption: ComparisonOption = {
  value: lastYearValue,
  label: 'Last Year',
  shortLabel: 'Last year',
};

const comparisonOptions: Array<ComparisonOption> = [
  teamOption,
  allTeamsOption,
  allGroupsOption,
  companyOption,
  selfOption,
  lastYearOption,
];
export default comparisonOptions;

export const defaultComparisonOption = selfOption;
